import { HistoryRouter as Router } from 'redux-first-history/rr6'
import App from 'containers/App'
import routes from 'modules/routes'
import { logUtil } from 'packages/src'
import React from 'react'
import { IntlProvider } from 'react-intl'
import { Provider } from 'react-redux'

export default function renderAppClientUtil (store, props) {
  logUtil('renderApp').info('props=', props)

  return (
    <Provider store={store}>
      <IntlProvider locale='en'>
        <Router {...props}>
          <App>
            {routes(store)}
          </App>
        </Router>
      </IntlProvider>
    </Provider>
  )
}
